import React from "react";
import { cls } from "cls";
import { AlignmentType, ImageVideoModel } from "../Models/PageCreatorPage";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";

const LeadGenImageVideo = ({
  imageAlignment,
  hasImageOrVideo,
  imageUrl,
  imageAltText,
  video,
  hasCaption,
  captionTextColor,
  caption,
  layoutStyles,
  content,
  hasDropShadow,
  imageVideoWidthClass,
}: ImageVideoModel): JSX.Element => {
  return (
    <div
      id="image-video-wrapper"
      className={`
        ${
          imageAlignment === AlignmentType.Left
            ? "lg:flex-row"
            : "lg:flex-row-reverse"
        }
        ${layoutStyles}
      `}
    >
      {hasImageOrVideo && (
        <div
          id="image-video-content"
          data-testid="image-video-content"
          className={cls(
            "flex",
            "flex-col",
            "space-y-4",
            "w-full",
            imageVideoWidthClass,
            hasDropShadow ? "drop-shadow-lg" : "",
          )}
        >
          {!!imageUrl && (
            <img
              id="content-img"
              src={imageUrl}
              alt={imageAltText}
              className="w-full mx-auto lg:max-w-full rounded-[0.10rem]"
            />
          )}
          {!!video && (
            <ZestVideoPlayer
              posterImage={video.poster}
              sources={video.sources}
              closedCaptionsrc={video.closedCaptionFile}
              currentIndex={0}
              selected={0}
              playsInline
            />
          )}
          {hasCaption && (
            <p
              className={cls("text-sm", "md:text-base")}
              style={{ color: captionTextColor, textAlign: "center" }}
            >
              {caption}
            </p>
          )}
        </div>
      )}
      {content}
    </div>
  );
};

export default LeadGenImageVideo;
